<h1 class="page-title mb-5"> المناطق الاستثمارية</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <p class="mb-4">
          عرف قانون الاستثمار رقم 72 لسنة 2017 المنطقة الاستثمارية بأنها منطقة جغرافية محددة المساحة والحدود، تخصص
          لإقامة
          نشاط معين أو أكثر من الأنشطة الاستثمارية المتخصصة وغيرها من الأنشطة المكملة لها، يقوم على تنميتها ووضع بنيتها
          الأساسية مطور لتلك المنطقة، والمطور هو كل شخص اعتباري يرخص له إنشاء منطقة استثمارية أو إدارتها أو تطويرها أو
          تنميتها وفقاً لأحكام هذا القانون.
        </p>
        <p class="mb-5">
          ويعتبر نظام المناطق الاستثمارية أحد الأنظمة الاستثمارية التي تقوم على نظام التنمية المتكاملة في مختلف المجالات
          لتتضمن أنشطة صناعية، تجارية، خدمية، لوجستية وغيرها من الأنشطة، وذلك بتوفير أراضي ووحدات صناعية كاملة المرافق
          من
          خلال مطورين متخصصين في مجال التطوير الصناعي لرفع عبء تكاليف الترفيق عن كاهل الدولة وتحقيق التنمية المتكاملة في
          مختلف المجالات، كما يتم من خلالها استصدار كافة الموافقات والتراخيص والتصاريح اللازمة للمستثمرين داخل تلك
          المناطق
          من جهة إدارية واحدة وهي الهيئة العامة للاستثمار وإجراءات ميسرة.
        </p>
        <img src="../../assets/inestments.jpg">

        <div class="mb-5">
          <a href="../../assets/منشور المناطق الاستثمارية.pdf" class="fs-5 fw-bold text-decoration-underline">لمنشور
            المناطق الاستثمارية اضغط هنا</a>
        </div>

        <h3 class="text-success fw-bold mb-4">ضوابط ومعايير إقامة المناطق الاستثمارية</h3>

        <div class="mb-4">
          <h5 class="text-danger fw-bold">أولا: موقف الحيازة للأرض</h5>
          <ol class="list-unstyled ps-4">
            <li class="mb-2 position-relative">
              <span class="d-block">لا يجوز إقامة منطقة استثمارية علي أرض غير ثابتة الملكية أو متنازع عليها.</span>
            </li>
            <li class="mb-2 position-relative">
              <span class="d-block">يجوز إقامة منطقة استثمارية على أرض متعاقد عليها بأي من صور التعاقد الواردة بقانون
                الاستثمار (شراء، إيجار، حق انتفاع).</span>
            </li>
          </ol>
        </div>

        <div class="mb-4">
          <h5 class="text-danger fw-bold">ثانيا: رأس المال</h5>
          <ul class="list-unstyled ps-4">
            <li class="mb-2 position-relative">
              <span class="d-block">يجب أن يتناسب رأس المال المصدر للمطور مع حجم التكاليف الاستثمارية المتوقعة لتنمية
                وتطوير المنطقة الاستثمارية.</span>
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="text-danger fw-bold">ثالثا: نوع الشركة</h5>
          <ul class="list-unstyled ps-4">
            <li class="mb-2 position-relative">
              <span class="d-block">يجب أن تكون الشركة مؤسسة بأحد القوانين المنظمة والسارية بجمهورية مصر العربية دون
                التقيد بالشكل القانوني على أن تكون الأولوية في الموافقة للشركات المؤسسة طبقا لقانون الاستثمار.</span>
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="text-danger fw-bold">رابعا: الموقع الجغرافي</h5>
          <ul class="list-unstyled ps-4">
            <li class="mb-2 position-relative">
              <span class="d-block">تكون الأولوية للموافقة على إقامة المناطق الاستثمارية بالمحافظات الأكثر احتياجا
                للتنمية والمناطق النائية وإقليم الصعيد.</span>
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="text-danger fw-bold">خامسا: استراتيجية تطوير المنطقة الاستثمارية</h5>
          <ul class="list-unstyled ps-4">
            <li class="mb-2 position-relative">
              <span class="d-block">يجب أن يضم المخطط العام المستهدف لإقامة المنطقة عدد من المشروعات المتجانسة أو
                المتكاملة من حيث الأنشطة المزمع ممارستها بالمنطقة الاستثمارية ويجوز تخصيص جزء من المنطقة لإقامة أنشطة
                متنوعة.</span>
            </li>
            <li class="mb-2 position-relative">
              <span class="d-block">يجوز إقامة مناطق استثمارية متخصصة تعمل بكافة الأنشطة الواردة باللائحة التنفيذية
                لقانون الاستثمار.</span>
            </li>
            <li class="mb-2 position-relative">
              <span class="d-block">المنطقة الاستثمارية تقام بنظام مشروعات التنمية المتكاملة حيث قد تتضمن أنشطة
                صناعية وتجارية وسكنية وخدمية ولوجستية وأنشطة أخرى مكملة فيما بينها.</span>
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h5 class="text-danger fw-bold">سادسا: البرنامج الزمني للتطوير</h5>
          <ul class="list-unstyled ps-4">
            <li class="mb-2 position-relative">
              <span class="d-block">يجب أن يتناسب البرنامج الزمني مع حجم المنطقة المتوقع تنفيذها وذلك في ضوء دراسة
                الجدوى المقدمة من المطور.</span>
            </li>
          </ul>
        </div>

        <div class="mb-5 d-flex align-items-center">
          <a href="../../assets/دليل اشتراطات ومعايير تنظيم العمل داخل المناطق الاستثمارية.pdf"
            class="fw-bold fs-5">دليل اشتراطات ومعايير تنظيم العمل داخل المناطق الاستثمارية</a>
        </div>

        <h3 class="text-success fw-bold mb-5">مراحل إقامة المناطق الاستثمارية</h3>
        <img src="../../assets/investment1.jpg">
        <h3 class="text-success fw-bold mb-5"> إدارة الإستثمار داخل المناطق الاستثمارية </h3>
        <img src="../../assets/investment2.jpg">


        <div class="section-header bg-light p-3 mb-4 border-start border-5 border-success">
          <h3 class="text-success m-0 fw-bold">مميزات المناطق الاستثمارية</h3>
        </div>
        <ul class="list-unstyled ps-4 mb-5">
          <li class="mb-2 position-relative"><span class="d-block">يتولى مجلس ادارة المنطقة الاستثمارية بوضع خطة عمل
              المنطقة وضوابط ومعايير مزاولة
              نشاطها</span></li>
          <li class="mb-2 position-relative"><span class="d-block">يختص مجلس ادارة المنطقة الاستثمارية بالموافقة على
              المشروعات داخلها</span></li>
          <li class="mb-2 position-relative"><span class="d-block">يتولى المكتب التنفيذي للمنطقة اصدار كافة التصاريح
              والموافقات والتراخيص اللازمة لإقامة
              المشروعات داخل المناطق الاستثمارية</span></li>
          <li class="mb-2 position-relative"><span class="d-block">لا يجوز لأي جهة ادارية بخلاف الهيئة العامة للاستثمار
              اتخاذ أي اجراءات داخل المناطق
              الاستثمارية الا بعد موافقة الهيئة</span></li>
          <li class="mb-2 position-relative"><span class="d-block">يختص رئيس مجلس ادارة المنطقة بالترخيص للمشروعات
              بمزاولة نشاطها</span></li>
          <li class="mb-2 position-relative"><span class="d-block">ويكتفي بهذا الترخيص عند التعامل مع كافة اجهزة الدولة
              دون الحاجة للقيد بالسجل
              الصناعي</span></li>
        </ul>
        <img src="../../assets/investment3.jpg">

        <div class="section-header bg-light p-3 mb-4 border-start border-5 border-success">
          <h3 class="text-success m-0 fw-bold">أهم الخدمات المقدمة داخل المناطق الاستثمارية</h3>
        </div>
        <ul class="list-unstyled ps-4 mb-5">
          <li class="mb-2 position-relative"><span class="d-block">استصدار الموافقات اللازمة من الجهات المعنية لإقامة
              المناطق الاستثمارية الجديدة</span>
          </li>
          <li class="mb-2 position-relative"><span class="d-block">اعتماد المخططات العامة والخاصة لإقامة المناطق
              الاستثمارية والمشروعات داخلها</span></li>
          <li class="mb-2 position-relative"><span class="d-block">الموافقة على المشروعات للعمل داخل المناطق
              الاستثمارية</span></li>
          <li class="mb-2 position-relative"><span class="d-block">استصدار ترخيص إنشاء وإدارة المرافق العامة والبنية
              الأساسية</span></li>
          <li class="mb-2 position-relative"><span class="d-block">استصدار ترخيص البناء وعمل المطابقات البنائية</span>
          </li>
          <li class="mb-2 position-relative"><span class="d-block">استصدار قرار الترخيص بمزاولة النشاط ( دائم /
              مؤقت)</span></li>
          <li class="mb-2 position-relative"><span class="d-block">استصدار الموافقات الخاصة بالجهات المعنية بالنشاط
              (الحماية المدنية / السلامة والصحة
              المهنية / البيئة) وغيرها</span></li>
        </ul>

        <p class="fw-bold fs-5 mb-5">دليل المناطق الاستثمارية</p>

        <div class="section-header bg-light p-3 mb-4 border-start border-5 border-success">
          <h3 class="text-success m-0 fw-bold">قصص النجاح</h3>
        </div>
        <p class="text-danger fw-bold text-center mb-5 fs-5">مناطق استثمارية متخصصة في الأنشطة الصناعية بمحافظة الجيزة "
          السادس من أكتوبر"</p>

        <div class="d-flex justify-content-start gap-4 align-items-start mb-5 flex-wrap">
          <img src="../../assets/logo1.png" alt="e2 October" class="success-story-logo">
          <img src="../../assets/logo2.jpg" alt="CPC" class="success-story-logo">
          <img src="../../assets/logo3.png" alt="Polaris Parks" class="success-story-logo">
        </div>

        <p class="text-danger fw-bold  mb-4 fs-5">مناطق استثمارية متخصصة في الأنشطة الصناعية بمحافظة الشرقية
          " العاشر من رمضان"</p>
        <div class="d-flex justify-content-start gap-4 align-items-start mb-5 flex-wrap">
          <img src="../../assets/logo4.jpg" alt="Al Tajamouat" class="success-story-logo">
          <img src="../../assets/logo5.jpg" alt="PI Parks" class="success-story-logo">
        </div>

        <p class="text-danger fw-bold  mb-4 fs-5">مناطق استثمارية متخصصة في الأنشطة الصناعية بمحافظة دمياط "
          مدينة دمياط الجديدة"</p>
        <div class="d-flex justify-content-start gap-4 align-items-start mb-5 flex-wrap">
          <img src="../../assets/logo6.jpg" alt="DFC" class="success-story-logo">
        </div>

        <p class="text-danger fw-bold  mb-4 fs-5">مناطق استثمارية متخصصة في الأنشطة الخدمية والترفيهية
          والتجارية</p>
        <div class="d-flex justify-content-start gap-4 align-items-start mb-4 flex-wrap">
          <img src="../../assets/logo7.jpg" alt="Emaar" class="success-story-logo">
          <img src="../../assets/logo8.png" alt="City Centre" class="success-story-logo">
          <img src="../../assets/logo9.jpg" alt="Majid Al Futtaim" class="success-story-logo">
        </div>
        <div class="d-flex justify-content-start gap-4 align-items-start mb-5 flex-wrap">
          <img src="../../assets/logo10.png" alt="Cairo Airport" class="success-story-logo">
          <img src="../../assets/logo11.jpg" alt="Arabia Holding" class="success-story-logo">
        </div>

        <p class="text-danger fw-bold  mb-4 fs-5">مناطق استثمارية متخصصة في الأنشطة اللوجستية</p>
        <div class="d-flex justify-content-start gap-4 align-items-start mb-5 flex-wrap">
          <img src="../../assets/logo12.png" alt="Orchid" class="success-story-logo">
        </div>

        <p class="text-danger fw-bold  mb-4 fs-5">مناطق استثمارية متخصصة في الأنشطة التعليمية</p>
        <div class="d-flex justify-content-start gap-4 align-items-start mb-5 flex-wrap">
          <img src="../../assets/logo13.png" alt="University" class="success-story-logo">
        </div>
        <p class="text-danger fw-bold  mb-4 fs-5">مناطق استثمارية متخصصة في أنشطة الصناعات الصغيرة والمتوسطة ولاية
          الهيئة</p>
        <img class="w-25 m-2" src="../../assets/area1.png">
        <img class="w-25 m-2" src="../../assets/areas.png">
        <img class="w-25 m-2" src="../../assets/area2.png">

      </div>



      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>